module.exports = __webpack_public_path__ + "static/media/employer_login_hero.7a8d577c.png";